module.exports = __webpack_public_path__ + "static/img/manual-36.42851b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-36.png
// module id = 7j37
// module chunks = 4